<template>
    <div class="job-offer-comparator">
      <table>
        <!-- Table Headers -->
        <tr>
          <th>Compensation Component</th>
          <th v-for="job in jobOffers" :key="job.id">Job {{ job.id }}</th>
        </tr>
  
        <!-- Base Salary Row -->
        <tr>
          <td>Base Salary: (hourly workers use your hourly wage x 1950 to estimate your base)</td>
          <td v-for="job in jobOffers" :key="job.id">
            <input v-model.number="job.baseSalary" type="number" placeholder="$" />
          </td>
        </tr>
  
        <!-- Dynamic Compensation Components -->
        <tr v-for="(comp, index) in compensationComponents" :key="index">
          <td>{{ comp.label }}</td>
          <td v-for="job in jobOffers" :key="job.id">
            <input v-model.number="job[comp.prop]" type="number" :placeholder="comp.placeholder" />
          </td>
        </tr>
  
        <!-- Total Compensation Row -->
    
          <th>Total Compensation:</th>
          <th v-for="job in jobOffers" :key="job.id">{{ formatCurrency(calculateTotalCompensation(job)) }}</th>
          <!-- Happiness Components for Each Job -->
          <tr>
          <th>Happiness Component</th>
          <th v-for="job in jobOffers" :key="job.id">Job {{ job.id }}</th>
        </tr>
  
        <!-- Loop through each happiness component -->
        <tr v-for="component in happinessComponents" :key="component.label">
          <td>{{ component.label }}</td>
          <td v-for="job in jobOffers" :key="job.id">
            <input type="range" v-model="job.happiness[component.label]" min="1" max="10" class="slider">
            <span>{{ job.happiness[component.label] }}</span>
          </td>
        </tr>
  
        <!-- Total Happiness Score Row -->
        <tr>
          <th>Total Happiness Score:</th>
          <th v-for="job in jobOffers" :key="job.id">{{ calculateTotalHappiness(job) }}</th>
        </tr>
      </table>
      <button @click="addJobOffer">Add Job Offer</button>
    </div>
  
  
  
   <br><br><br><br><br><br>
  </template>
  
  <script>
  import { ref, reactive } from 'vue';
  
  export default {
    setup() {
      const jobOffers = reactive([
        { id: 'A', baseSalary: 0, commission: 0, bonus: 0, overtime: 0, rrsp: 0, stockoptions: 0, remote: 0, hybrid: 0, vacation: 0, medical: 0, insurance: 0, dental: 0, learn: 0,  happiness: { 'Commute time': 0, 'Travel Required': 0, 'Learning and Development': 0, 'Career Progression': 0, 'Company Reputation': 0, 'Commitment to DEI': 0, 'Job Stability': 0, 'Job Stress Level': 0, 'Leadership style of Direct Manager': 0, 'Gut Feeling': 0 }},
        { id: 'B', baseSalary:0, commission: 0, bonus: 0, overtime: 0, rrsp: 0, stockoptions: 0, remote: 0, hybrid: 0, vacation: 0, medical: 0, insurance: 0, dental: 0, learn: 0, happiness: { 'Commute time': 0, 'Travel Required': 0, 'Learning and Development': 0, 'Career Progression': 0, 'Company Reputation': 0, 'Commitment to DEI': 0, 'Job Stability': 0, 'Job Stress Level': 0, 'Leadership style of Direct Manager': 0, 'Gut Feeling': 0}},
        // Initialize Job C similarly
      ]);
  
      const compensationComponents = ref([
    { label: 'Commission:', prop: 'commission', placeholder: '$' },
      { label: 'Bonus Potential:', prop: 'bonus', placeholder: '$' },
      { label: 'Overtime Value:', prop: 'overtime', placeholder: '$' },
      { label: 'RRSP Match (max)', prop: 'rrsp', placeholder: '$' },
      { label: 'Stock Options', prop: 'stockoptions', placeholder: '$' },
      { label: 'Remote First Environment (how much $ saved not commuting):', prop: 'remote', placeholder: '$' },
      { label: 'Hybrid Schedule', prop: 'hybrid', placeholder: '$' },
      { label: 'Vacation Allotment : ($ Estimate: Salary / 52 x # of weeks)', prop: 'vacation', placeholder: '$' },
      { label: 'Employer Benefits - Medical Plan:', prop: 'medical', placeholder: '$' },
      { label: 'Employer Benefits - Life & Travel Insurance:', prop: 'insurance', placeholder: '$' },
      { label: 'Employer Benefits - Dental Insurance', prop: 'dental', placeholder: '$' },
      { label: 'Employer Benefits - Learning & Development Credit', prop: 'learn', placeholder: '$' },
     
  
        // Add other components as needed
      ]);
  
      const happinessComponents = ref([
        { label: 'Commute Time (+points for lesser commute)', value: 3 },
        { label: 'Travel Required ', value: 3 },
        { label: 'Learning and Development', value: 3 },
        { label: 'Career Progression', value: 3 },
        { label: 'Company Reputation', value: 3 },
        { label: 'Commitment to DEI', value: 3 },
        { label: 'Job Stability', value: 3 },
        { label: 'Job Stress Level', value: 3 },
        { label: 'Leadership style of Direct Manager', value: 3 },
        { label: 'Gut Feeling', value: 3 },
  
        // ... add other components
      ]);
  
      function addJobOffer() {
    const newId = String.fromCharCode(jobOffers[jobOffers.length - 1].id.charCodeAt(0) + 1);
    jobOffers.push({ 
      id: newId, 
      baseSalary: 0, 
      commission: 0, 
      bonus: 0, 
      overtime: 0,
      rrsp: 0, 
      stockoptions: 0, 
      remote: 0, 
      hybrid: 0, 
      vacation: 0, 
      medical: 0, 
      insurance: 0, 
      dental: 0, 
      learn: 0,
      happiness: {
        'Commute time': 0, 
        'Travel Required': 0, 
        'Learning and Development': 0, 
        'Career Progression': 0, 
        'Company Reputation': 0, 
        'Commitment to DEI': 0, 
        'Job Stability': 0, 
        'Job Stress Level': 0, 
        'Leadership style of Direct Manager': 0, 
        'Gut Feeling': 0
      }
    });
  }
  
      function calculateTotalCompensation(job) {
        // Add logic to calculate total compensation based on various components
        let total = job.baseSalary;
        total += job.commission;
        total += job.bonus;
        total += job.overtime;
        total += job.rrsp;
        total += job.remote;
        total += job.hybrid;
        total += job.vacation;
        total += job.medical;
        total += job.insurance;
        total += job.dental;
        total += job.learn
        return total;
      }
  
      function formatCurrency(value) {
        return '$' + value.toLocaleString();
      }
  
      function calculateTotalHappiness(job) {
    // Ensure each value is treated as a number during summation
    return Object.values(job.happiness).reduce((total, value) => total + Number(value), 0);
  }
  
      return {
        jobOffers,
        compensationComponents,
        addJobOffer,
        calculateTotalCompensation,
        formatCurrency,
        happinessComponents,
        calculateTotalHappiness
      };
    }
  };
  </script>
  <style scoped>
  .job-offer-comparator {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f4f4f8; /* Light background for a clean look */
    color: #333; /* Dark text for readability */
    padding: 10px;
    border-radius: 10px;
    margin: 10px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* Soft shadow for depth */
    font-family: Arial, sans-serif; /* Consistent font */
  }
  
  .job-offer-comparator table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  .job-offer-comparator th, .job-offer-comparator td {
    border: 1px solid #ddd; /* Light border for a cleaner look */
    padding: 8px;
    text-align: left;
  }
  
  .job-offer-comparator th {
    background-color: #eee; /* Light header background */
  }
  
  .job-offer-comparator input[type="number"], .job-offer-comparator input[type="range"] {
    width: calc(100% - 10px); /* Adjusting width to compensate for padding */
    padding: 4px; /* Reduced padding for compactness */
    margin: 4px 0; /* Tighter margin */
    border: 1px solid #ccc; /* Subtle border */
    border-radius: 5px; /* Rounded corners */
    font-size: 14px; /* Smaller font size for compactness */
  }
  
  button {
    background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%);
    color: white;
    border: none;
    padding: 8px 12px; /* Reduced padding for buttons */
    border-radius: 5px;
    margin: 5px;
    cursor: pointer;
    transition: background-color 0.3s, box-shadow 0.3s;
  }
  
  button:hover {
    box-shadow: 0 4px 8px rgba(0,0,0,0.2); /* Enhanced shadow on hover */
  }
  
  /* Responsive design adjustments */
  @media screen and (max-width: 480px) {
    .job-offer-comparator {
      padding: 5px;
      margin: 5px;
    }
  
    .job-offer-comparator th, .job-offer-comparator td {
      padding: 4px; /* Even smaller padding for table cells */
    }
  
    .job-offer-comparator input[type="number"], .job-offer-comparator input[type="range"] {
      padding: 3px; /* Further reduced padding for inputs */
      margin: 2px 0; /* Reduced margin */
      font-size: 13px; /* Adjusted font size for smaller screens */
    }
  
    button {
      padding: 7px 10px; /* Smaller buttons */
      font-size: 14px; /* Adjusted button font size */
    }
  }
  </style>